import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AutorisationBnbaccess } from './autorisation-bnbaccess.model';
import { AutorisationBnbaccessService } from './autorisation-bnbaccess.service';
@Injectable()
export class AutorisationBnbaccessPopupService {
    private isOpen = false;
    constructor (
        private modalService: NgbModal,
        private router: Router,
        private autorisationService: AutorisationBnbaccessService

    ) {}

    open (component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.autorisationService.find(id).subscribe(autorisation => {
                this.autorisationModalRef(component, autorisation);
            });
        } else {
            return this.autorisationModalRef(component, new AutorisationBnbaccess());
        }
    }

    autorisationModalRef(component: Component, autorisation: AutorisationBnbaccess): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.autorisation = autorisation;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/autorisation/autorisation-bnbaccess-popup.service.ts